<template>
  <div class="space-y-4">
    <div class="flex items-center space-x-3">
      <AddFacebookChannel :campaign-id="campaign.id" @saved="fetchCampaignChannels" />
      <AddGoogleAdsChannel :campaign-id="campaign.id" @saved="fetchCampaignChannels" />
    </div>
    <ul class="space-y-2">
      <li v-for="channel in channels" :key="channel.id">
        <ChannelLine
          :channel="channel"
          :campaign="campaign"
          @changed="fetchCampaignChannels"
          @deleted="fetchCampaignChannels"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { campaignChannelsClient } from '@/api/clients';
import AddFacebookChannel from './tabChannels/AddFacebookChannel.vue';
import AddGoogleAdsChannel from './tabChannels/AddGoogleAdsChannel.vue';
import ChannelLine from './tabChannels/ChannelLine.vue';

export default {
  components: {
    AddFacebookChannel,
    AddGoogleAdsChannel,
    ChannelLine,
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      channels: [],
    };
  },
  created() {
    this.fetchCampaignChannels();
  },
  methods: {
    async fetchCampaignChannels() {
      try {
        const response = await campaignChannelsClient.list(this.campaign.id, {
          params: {
            include: 'channable,page,project.pages',
          },
        });

        if (Array.isArray(response.data?.data)) {
          this.channels = response.data.data;
        }
      } catch (error) {
        //
      }
    },
  },
};
</script>
